import { render, staticRenderFns } from "./AccommodationCategory.vue?vue&type=template&id=9680dc4e&"
import script from "./AccommodationCategory.vue?vue&type=script&lang=js&"
export * from "./AccommodationCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccommodationCategory.vue"
export default component.exports